import React, { useEffect, useState, useRef } from "react";
import {
  getVehicleByLicensePlate,
  getVehicleProfileGroups,
  getVehicleProfileRentalPackages,
  getCityName,
  getVehicleProfileDocuments,
  getVehicleProfileImages,
  getVehicleProfileFinancialDetails,
  getVehicleGroupsByCity,
  getHubName,
  getBikeProfileRentalPackages,
} from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import VehicleDocuments from "./Vehicledocuments";
import Vehicleimages from "./Vehicleimages";
import Vehiclefinancialdetails from "./Vehiclefinancialdetails";
import Nonrevenuekm from "./Nonrevenuekm";
import Mybookings from "./Mybookings";
import Myissues from "./Myissues";
import Myexpenses from "./Myexpenses";
import Batteries from "./Batteries";
import Commonmodal from "../../common/Commonmodal";
import Mygroup from "./Mygroup";
import Mypackages from "./Mypackages";
import toast from "react-hot-toast";
import fileUpload from "../../common/fileupload";
import cardefault from "../../assets/cardefault.webp";
import Mytyres from "./Mytyres";
import Myclutch from "./Myclutch";
import Specifications from "./Specifications";
import Wheelalignmentlogs from "./Wheelalignmenlogs";
import getactions from "../../common/getactions";
import { useSelector } from "react-redux";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import Myworkorders from "./Myworkorders";
import Mywindshield from "./Mywindshield";
import Mysubscription from "./Mysubscription";
import Mybikerentalpackage from "./Mybikerentalpackage";

export default function VehicleProfile({
  systemUserList,
  setOpenTab,
  selectedRow,
}) {
  // const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const queryVehicleId = new URLSearchParams(window.location.search).get(
    "vehicleId",
  );
  let profile = JSON.parse(localStorage.getItem("profile"));
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const vehicleStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleStatus;
  const transmissionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.transmissionType;
  const fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  const vehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  const vehicleType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleType;
  const [activeTab, setActiveTab] = useState("summary");
  const [firstLoading, setFirstLoading] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const tabsContainerRef = useRef(null);
  const [vehicleProfileData, setVehcileProfileData] = useState(null);
  const [myGroups, setMyGroups] = useState(null);
  const [rentalPackages, setRentalPackages] = useState([]);
  const [cities, setCities] = useState({});
  const [hubs, setHubs] = useState([]);
  const [vehicleDocuments, setVehicleDocuments] = useState([]);
  const [vehicleImages, setVehicleImages] = useState([]);
  // const [vehileFinancialDetails, setVehicleFinancialDetails] = useState(null);
  const [openImageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [groupsList, setGroupsList] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [createNewGroupModal, setCreateNewGroupModal] = useState(false);
  const [packageRows, setPackageRows] = useState([]);
  const subCategoryfuelType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fuelType;
  const subCategoryfuelTypeDuplicate = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fuelType;
  delete subCategoryfuelType?.inverted;
  const subCatgoryvehicleStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleStatus;
  delete subCatgoryvehicleStatus?.inverted;
  const subCategroytransmissionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.transmissionType;
  delete subCategroytransmissionType?.inverted;
  const subCategoryvehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  delete subCategoryvehicleBodyType?.inverted;
  let subCatergorySegmentType = {
    "Essential – Hatchback": "Essential – Hatchback",
    "Elite – Sedan": "Elite – Sedan",
    "Explorer – Compact SUV": "Explorer – Compact SUV",
    "Signature – SUV": "Signature – SUV",
  };
  let subcategoryValues = {
    fuelType: Object.entries(subCategoryfuelType).map(([key, value]) => {
      return {
        value: key,
        label: value,
      };
    }),
    transmissionType: Object.entries(subCategroytransmissionType).map(
      ([key, value]) => {
        return {
          value: key,
          label: value,
        };
      },
    ),
    vehicleBodyType: Object.entries(subCategoryvehicleBodyType).map(
      ([key, value]) => {
        return {
          value: key,
          label: value,
        };
      },
    ),
    vehicleStatus: Object.entries(subCatgoryvehicleStatus).map(
      ([key, value]) => {
        return {
          value: key,
          label: value,
        };
      },
    ),
    segmentType: Object.entries(subCatergorySegmentType).map(([key, value]) => {
      return {
        value: key,
        label: value,
      };
    }),
    citiesText: Object.entries(cities).map(([key, value]) => {
      return {
        value: key,
        label: value,
      };
    }),
    hubsList: hubs?.map((item, index) => {
      return {
        value: item?.id,
        label: item?.hubName,
      };
    }),
    groupList: groupsList?.map((item, index) => {
      return {
        value: item?.id,
        label: item?.name,
      };
    }),
    vehicleType: Object.entries(vehicleType || {})
      .filter(([key]) => key !== "inverted")
      .map(([key, value]) => ({
        value: key,
        label: value,
      })),
    isAssociateVehicle: [
      { label: "Yes", value: "1" },
      { label: "No", value: "0" },
    ],
    isSubscriptionEnabled: [
      { label: "True", value: true },
      { label: "False", value: false },
    ],
  };
  const authHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `${token}`,
  };
  const [formData, setFormData] = useState(null);
  const [createNewGroupFrom, setCreateNewGroupForm] = useState(null);
  const [loadingGroups, setLoadingGroups] = useState(false);

  useEffect(() => {
    if (vehicleProfileData?.length) {
      const v = vehicleProfileData[0];
      setFormData({
        engineNo: v.engineNo ?? "",
        chasisNo: v.chasisNo ?? "",
        // vehicleMakeText: v.vehicleMakeText ?? "",
        // vehicleModelText: v.vehicleModelText ?? "",
        // vehicleVariantText: v.vehicleVariantText ?? "",
        fuelTankCapacity: v.fuelTankCapacity ?? "",
        seater: v.seater ?? "",
        onBoardingOdometer: v.onBoardingOdometer ?? "",
        currentOdometer: v.currentOdometer ?? "",
        vehicleBodyType: v.vehicleBodyType ?? "",
        fuelType: v.fuelType ?? "",
        segment: v.segment ?? "",
        transmissionType: v.transmissionType ?? "",
        registrationDate: v.registrationDate ?? "",
        onBoardingDate: v.onBoardingDate ?? "",
        status: v.status,
        imageUrl: v.imageUrl,
        hubId: v?.hubId,
        licensePlate: v?.licensePlate,
        cityId: v?.cityId,
        vehicleGroupText: v?.vehicleGroupId,
        vehicleType: v.vehicleType ?? "",
        name: v?.name ?? "",
        isSubscriptionEnabled: v?.isSubscriptionEnabled,
        engineCapacity: v?.engineCapacity ?? "",
        drivingRange: v?.drivingRange ?? "",
        chargingTime: v?.chargingTime ?? "",
        chargingType: v?.chargingType ?? "",
      });
    }
  }, [vehicleProfileData, isEdit]);

  useEffect(() => {
    if (formData?.cityId) {
      setCreateNewGroupForm({
        city: formData?.cityId,
      });
    }
  }, [formData?.cityId]);

  const getValue = (key) => {
    if (key === "vehicleBodyType") {
      return isEdit
        ? formData?.[key]
        : vehicleBodyType[vehicleProfileData[0]?.[key]];
    } else if (key === "transmissionType") {
      return isEdit
        ? formData?.[key]
        : transmissionType[vehicleProfileData[0]?.[key]];
    } else if (key === "fuelType") {
      return isEdit ? formData?.[key] : fuelType[vehicleProfileData[0]?.[key]];
    } else if (key === "cityId") {
      return isEdit ? formData?.[key] : cities[vehicleProfileData[0]?.[key]];
    } else if (key === "hubId") {
      return isEdit
        ? hubs.filter((hub) => String(hub.id) === String(formData?.[key]))[0]
          ?.hubName
        : hubs.filter(
          (hub) => String(hub.id) === String(vehicleProfileData[0]?.[key]),
        )[0]?.hubName;
    } else if (key === "status") {
      return isEdit
        ? formData?.[key]
        : vehicleStatus[vehicleProfileData[0]?.[key]];
    } else if (key === "vehicleType") {
      return isEdit
        ? formData?.[key]
        : vehicleType[vehicleProfileData[0]?.[key]];
    } else if (key === "isAssociateVehicle") {
      return isEdit
        ? formData?.[key]
        : vehicleProfileData[0]?.[key] === true
          ? "Yes"
          : "No";
    } else if (key === "isSubscriptionEnabled") {
      return isEdit
        ? formData?.[key]
        : vehicleProfileData[0]?.[key] === true
          ? "True"
          : "False";
    } else {
      return isEdit ? formData?.[key] : vehicleProfileData[0]?.[key];
    }
  };

  const handleChange = (key, value) => {
    if (key === "cityId") {
      setFormData((prev) => ({
        ...prev,
        vehicleGroupText: "",
      }));
      getHubsAPI(value);
      getGroupsAPI(value);
      setFormData((prev) => ({
        ...prev,
        [key]: value,
      }));
    } else
      setFormData((prev) => ({
        ...prev,
        [key]: value,
      }));
  };

  const handleNewGroupCreate = (key, value) => {
    setCreateNewGroupForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // Scroll tabs functionality
  const checkScroll = () => {
    if (tabsContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = tabsContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScroll();
    const container = tabsContainerRef.current;
    if (container) {
      container.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      return () => {
        container.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
      };
    }
  }, []);

  useEffect(() => {
    const groupId = vehicleProfileData?.[0]?.vehicleGroupId;
    if (groupId) {
      getSubscriptionPAckageDetails(groupId);
      // getAllHubsList();
    }
  }, [vehicleProfileData?.[0]?.vehicleGroupId]);

  const scroll = (direction) => {
    if (tabsContainerRef.current) {
      const scrollAmount = 200;
      if (direction === "left") {
        tabsContainerRef.current.scrollBy({
          left: -scrollAmount,
          behavior: "smooth",
        });
      } else {
        tabsContainerRef.current.scrollBy({
          left: scrollAmount,
          behavior: "smooth",
        });
      }
      setTimeout(checkScroll, 300);
    }
  };

  const handleSave = async () => {
    let payload = {
      id: selectedRow?.id,
      name: formData?.name || null,
      licensePlate: formData?.licensePlate || null,
      chasisNo: formData?.chasisNo || null,
      engineNo: formData?.engineNo || null,
      vehicleBodyType: formData?.vehicleBodyType || null,
      fuelType: formData?.fuelType || null,
      transmissionType: formData?.transmissionType || null,
      seater: formData?.seater || null,
      fuelTankCapacity: formData?.fuelTankCapacity || null,
      registrationDate: formData?.registrationDate || null,
      vehicleType: formData?.vehicleType || null,
      onBoardingDate: formData?.onBoardingDate
        ? formData?.onBoardingDate
        : null,
      segment: formData?.segment || null,
      onBoardingOdometer: formData?.onBoardingOdometer || null,
      currentOdometer: formData?.currentOdometer || null,
      imageUrl: uploadedImages
        ? uploadedImages[0]?.Location
        : vehicleProfileData[0]?.imageUrl,
      status: formData?.status
        ? formData?.status
        : vehicleProfileData[0]?.status,
      cityId: formData?.cityId
        ? formData?.cityId
        : vehicleProfileData[0]?.cityId,
      hubId: formData?.hubId ? formData?.hubId : vehicleProfileData[0]?.hubId,
      cityText: formData?.cityId
        ? cities[formData?.cityId]
        : cities[vehicleProfileData[0]?.cityId],
      vehicleGroupId: formData?.vehicleGroupText
        ? Number(formData?.vehicleGroupText)
        : Number(vehicleProfileData[0]?.vehicleGroupId),
      vehicleGroupText: formData?.vehicleGroupText
        ? groupsList.find(
          (item) => String(item?.id) === String(formData?.vehicleGroupText),
        )?.name
        : vehicleProfileData[0]?.vehicleGroupText,
      isAssociateVehicle: formData?.isAssociateVehicle || null,
      isSubscriptionEnabled: formData?.isSubscriptionEnabled || null,
      drivingRange: formData?.drivingRange || null,
      chargingTime: formData?.chargingTime || null,
      chargingType: formData?.chargingType || null,
      engineCapacity: formData?.engineCapacity || null,
    };
    try {
      const response = await fetch(`${apiUrl}/api/vehicles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        toast.success("Vehicle Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setIsEdit(false);
        setFormData({});
        setUploadedImages(null);
        await getVehicleByLicensePlateAPI(selectedRow?.registrationno);
      } else {
        toast.error(data?.msg || data?.message);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle creation:", error);
    }
  };

  const handleSavedNewGroupData = async () => {
    let payload = {
      name: createNewGroupFrom?.groupName,
      code: createNewGroupFrom?.groupCode,
      cityId: createNewGroupFrom?.city,
      securityDeposit: createNewGroupFrom?.securityDeposit,
    };
    try {
      const response = await fetch(`${apiUrl}/api/vehiclegroups`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success(
          `New Group Created Successfully for ${cities[createNewGroupFrom?.city]}`,
          {
            position: "bottom-center",
            style: {
              background: "blue",
              color: "white",
              fontWeight: "medium",
              marginBottom: "50px",
            },
          },
        );
        setCreateNewGroupModal(false);
        setCreateNewGroupForm({});
        await getGroupsAPI(formData?.cityId);
      } else {
        toast.error(data?.msg || data?.message);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle creation:", error);
    }
  };

  const handleImageClose = () => {
    setSelectedImage(null);
    setImageModal(false);
  };

  const handleImageOpen = (url) => {
    setSelectedImage(url);
    setImageModal(true);
  };

  const getVehicleByLicensePlateAPI = async (vehicleRegistration) => {
    setFirstLoading(true);
    const apiDetails = await getVehicleByLicensePlate(vehicleRegistration);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setFirstLoading(false);
      setVehcileProfileData(data?.entities?.rows);
      await getVehicleProfileGroupsAPI(data?.entities?.rows[0]?.vehicleGroupId);
      await getVehicleProfileRentalPackagesAPI(
        data?.entities?.rows[0]?.vehicleGroupId,
        data?.entities?.rows,
      );
    }
  };

  const getSubscriptionPAckageDetails = async (groupId) => {
    setLoadingGroups(true);
    try {
      let url = `${apiUrl}/api/subscriptionpackages?groupId=${groupId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: authHeaders,
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPackageRows(data?.entities?.rows || []);
      } else {
        toast.error(
          data?.msg || data?.message || "Failed to fetch Subcription packages",
        );
      }
    } catch (error) {
      console.error("Error fetching Subscription packages:", error);
      toast.error("Error fetching Subscription packages");
    } finally {
      setLoadingGroups(false);
    }
  };

  const getVehicleProfileRentalPackagesAPI = async (
    groupId,
    profileData = vehicleProfileData,
  ) => {
    if (
      String(profileData?.[0]?.vehicleType) ===
      String(vehicleType?.inverted?.bike)
    ) {
      await getBikeProfileRentalPackagesAPI(groupId);
    } else {
      const apiDetails = await getVehicleProfileRentalPackages(groupId);
      const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
      if (data) {
        setRentalPackages(data?.entities?.rows);
      }
    }
  };

  const getBikeProfileRentalPackagesAPI = async (groupId) => {
    const apiDetails = await getBikeProfileRentalPackages(groupId);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setRentalPackages(data?.entities?.rows);
    }
  };

  const getCitiesAPI = async () => {
    const apiDetails = await getCityName();
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setCities(data);
    }
  };

  const getHubsAPI = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setHubs(data?.entities?.rows);
    }
  };

  const getVehicleProfileGroupsAPI = async (groupId) => {
    const apiDetails = await getVehicleProfileGroups(groupId);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setMyGroups(data?.entityValue);
    }
  };

  const getVehicleProfileDocumentsAPI = async (vehicleID) => {
    const apiDetails = await getVehicleProfileDocuments(vehicleID);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setVehicleDocuments(data?.entities?.rows);
    }
  };

  const getVehicleProfileImagesAPI = async (vehicleID) => {
    const apiDetails = await getVehicleProfileImages(vehicleID);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setVehicleImages(data?.entities?.rows);
    }
  };

  const getGroupsAPI = async (cityId) => {
    const apiDetails = await getVehicleGroupsByCity(cityId);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setGroupsList(data?.entities?.rows || []);
  };

  useEffect(() => {
    if (vehicleProfileData) {
      getGroupsAPI(vehicleProfileData[0]?.cityId);
    }
  }, [vehicleProfileData]);

  useEffect(() => {
    if (queryVehicleId) {
      getVehicleByLicensePlateAPI(
        selectedRow?.registrationno || queryVehicleId,
      );
    }
  }, [queryVehicleId]);

  useEffect(() => {
    if (selectedRow?.registrationno) {
      getVehicleByLicensePlateAPI(selectedRow?.registrationno);
      getCitiesAPI();
      getVehicleProfileDocumentsAPI(selectedRow?.id);
      getVehicleProfileImagesAPI(selectedRow?.id);
    }
  }, [selectedRow?.registrationno]);

  useEffect(() => {
    if (vehicleProfileData) {
      getHubsAPI(vehicleProfileData[0]?.cityId);
    }
  }, [vehicleProfileData]);

  const tabs = [
    { id: "summary", label: "Summary" },
    { id: "documents", label: "Documents" },
    { id: "images", label: "Images" },
    { id: "financial", label: "Financial Details" },
    ...(actionsToAccess?.includes("View And Add Vehicle Finance Details")
      ? [{ id: "financial", label: "Financial Details" }]
      : []),
    { id: "batteries", label: "Batteries" },
    { id: "mytyres", label: "Tyres" },
    { id: "myclutch", label: "Clutch" },
    { id: "windshield", label: "Wind shield" },
    { id: "wheelalignmentlogs", label: "Wheel Alignment Logs" },
    { id: "nonrevenue", label: "My Non Revenue Kms" },
    { id: "mybookings", label: "My Bookings" },
    { id: "myissues", label: "My Issues" },
    { id: "myworkorders", label: "My Workorders" },
    { id: "myexpenses", label: "My Expenses" },
  ];

  const handleImageChange = async (value) => {
    await fileUpload(value, "vehicles", "vehicle").then((res) => {
      setUploadedImages([res]);
    });
  };

  return (
    <>
      {openImageModal && (
        <>
          <Commonmodal
            open={handleImageOpen}
            onClose={handleImageClose}
            url={selectedImage}
          />
        </>
      )}

      {createNewGroupModal && (
        <>
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
            <div className="bg-white w-full max-w-lg rounded-xl shadow-xl p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Create New Group</h3>
                <button onClick={() => setCreateNewGroupModal(false)}>
                  <X className="text-slate-500 hover:text-red-500" />
                </button>
              </div>

              <div className="space-y-4">
                <input
                  name="group name"
                  placeholder="Group Name"
                  required
                  className="w-full border rounded-lg px-4 py-2 text-sm"
                  value={createNewGroupFrom?.groupName}
                  onChange={(e) =>
                    handleNewGroupCreate("groupName", e.target.value)
                  }
                />

                <input
                  name="group code"
                  placeholder="Group Code"
                  required
                  className="w-full border rounded-lg px-4 py-2 text-sm"
                  value={createNewGroupFrom?.groupCode}
                  onChange={(e) =>
                    handleNewGroupCreate("groupCode", e.target.value)
                  }
                />
                <input
                  name="security deposit"
                  placeholder="Security Deposit"
                  required
                  className="w-full border rounded-lg px-4 py-2 text-sm"
                  value={createNewGroupFrom?.securityDeposit}
                  onChange={(e) =>
                    handleNewGroupCreate("securityDeposit", e.target.value)
                  }
                />
                <input
                  name="city"
                  placeholder="City"
                  required
                  disabled
                  className="w-full border rounded-lg px-4 py-2 text-sm"
                  value={cities[createNewGroupFrom?.city]}
                  onChange={(e) => handleNewGroupCreate("city", e.target.value)}
                />
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setCreateNewGroupModal(false)}
                  className="px-4 py-2 border rounded-lg text-sm"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSavedNewGroupData}
                  className="px-5 py-2 bg-teal-600 text-white rounded-lg text-sm hover:bg-teal-700"
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="flex h-screen">
        <div className="flex-1 overflow-auto p-6 space-y-6 scrollbar-hide">
          <div className="bg-white rounded-xl border border-gray-200">
            <div className="border-b px-6 flex justify-between items-center">
              {/* Left Arrow */}
              <button
                onClick={() => scroll("left")}
                disabled={!canScrollLeft}
                className={`flex-shrink-0 mr-2 p-2 rounded-lg transition-all ${canScrollLeft
                  ? "bg-gray-100 hover:bg-gray-200 text-gray-700"
                  : "bg-gray-50 text-gray-400 cursor-not-allowed"
                  }`}
              >
                <ChevronLeft size={20} />
              </button>

              <div
                ref={tabsContainerRef}
                className="flex gap-6 flex-1 min-w-0 overflow-x-auto hide-scrollbar scroll-smooth"
              >
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-4 text-sm font-semibold border-b-2 whitespace-nowrap transition-all duration-200
        ${activeTab === tab.id
                        ? "border-teal-600 text-teal-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* Right Arrow */}
              <button
                onClick={() => scroll("right")}
                disabled={!canScrollRight}
                className={`flex-shrink-0 ml-2 p-2 rounded-lg transition-all ${canScrollRight
                  ? "bg-gray-100 hover:bg-gray-200 text-gray-700"
                  : "bg-gray-50 text-gray-400 cursor-not-allowed"
                  }`}
              >
                <ChevronRight size={20} />
              </button>

              <div className="flex-shrink-0 ml-4">
                <button
                  className="bg-white text-center w-56 rounded-2xl h-14 relative text-black text-xl font-semibold group"
                  type="button"
                  onClick={() => {
                    setOpenTab(false);
                  }}
                >
                  <div className="bg-green-400 rounded-xl h-12 w-1/4 flex items-center justify-center absolute left-1 top-[4px] group-hover:w-[194px] z-10 duration-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1024 1024"
                      height="25px"
                      width="25px"
                    >
                      <path
                        d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"
                        fill="#000000"
                      />
                      <path
                        d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
                        fill="#000000"
                      />
                    </svg>
                  </div>
                  <p className="translate-x-2">Go Back</p>
                </button>
              </div>
            </div>

            {activeTab === "summary" ? (
              <>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <div className="h-5 w-1 rounded bg-teal-600"></div>
                      <h2 className="text-lg font-semibold text-slate-800">
                        Vehicle Info
                      </h2>
                    </div>
                  </div>

                  {vehicleProfileData && (
                    <>
                      <div className="grid grid-cols-12 gap-6">
                        <div className="col-span-4">
                          {!isEdit ? (
                            <img
                              src={
                                vehicleProfileData[0]?.imageUrl
                                  ? vehicleProfileData[0]?.imageUrl
                                  : cardefault
                              }
                              alt="Vehicle"
                              className="w-full h-96 object-cover rounded-xl border border-gray-200 mb-4"
                            />
                          ) : (
                            <div className="w-full h-96 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl">
                              {!uploadedImages ? (
                                <div className="relative h-48 rounded-lg border-2 border-blue-500 bg-gray-50 flex justify-center items-center shadow-lg hover:shadow-xl transition-shadow duration-300 ease-in-out">
                                  <div className="absolute flex flex-col items-center pointer-events-none">
                                    <img
                                      alt="File Icon"
                                      className="mb-3"
                                      src="https://img.icons8.com/dusk/64/000000/file.png"
                                    />

                                    <span className="block text-gray-400 font-normal mt-1">
                                      Click to upload
                                    </span>
                                  </div>

                                  <input
                                    type="file"
                                    accept="image/*"
                                    className="h-full w-full opacity-0 cursor-pointer"
                                    onChange={(e) =>
                                      handleImageChange(e.target.files[0])
                                    }
                                  />
                                </div>
                              ) : (
                                <div className="mt-6 flex gap-4 flex-wrap">
                                  {uploadedImages.map((image, index) => (
                                    <>
                                      <img
                                        key={index}
                                        src={
                                          image?.url ||
                                          image?.Location ||
                                          image?.path ||
                                          image
                                        }
                                        alt="uploaded"
                                        className="rounded-lg object-cover border shadow"
                                      />
                                      <input
                                        type="file"
                                        accept="image/*"
                                        placeholder="Click to Upload"
                                        className="h-10 w-28 cursor-pointer"
                                        onChange={(e) =>
                                          handleImageChange(e.target.files[0])
                                        }
                                      />
                                    </>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        <div className="col-span-8">
                          <div className="flex justify-end mb-4">
                            {isEdit ? (
                              <div className="flex gap-4">
                                <button
                                  onClick={handleSave}
                                  className="px-4 py-2 bg-blue-500 text-white rounded-md"
                                >
                                  Save
                                </button>
                                <button
                                  onClick={() => {
                                    setIsEdit(false);
                                    setFormData({});
                                    setUploadedImages(null);
                                  }}
                                  className="px-4 py-2 bg-red-500 text-white rounded-md"
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              <button
                                onClick={() => setIsEdit(true)}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md"
                              >
                                Edit
                              </button>
                            )}
                          </div>

                          <div className="grid grid-cols-4 gap-x-8 gap-y-6">
                            <Field
                              label="Name"
                              value={getValue("name")}
                              fieldKey="name"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="text"
                            />

                            <Field
                              label="Registration No"
                              value={getValue("licensePlate")}
                              fieldKey="licensePlate"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="text"
                            />

                            <Field
                              label="Is Associate Vehcile"
                              value={getValue("isAssociateVehicle")}
                              fieldKey="isAssociateVehicle"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={
                                subcategoryValues?.isAssociateVehicle
                              }
                            />

                            <Field
                              label="City"
                              value={getValue("cityId")}
                              fieldKey="cityId"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={subcategoryValues?.citiesText}
                            />

                            <Field
                              label="Hub"
                              value={getValue("hubId")}
                              fieldKey="hubId"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={subcategoryValues?.hubsList}
                            />

                            <Field
                              label="Group"
                              value={getValue("vehicleGroupText")}
                              fieldKey="vehicleGroupText"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={subcategoryValues?.groupList}
                              setCreateNewGroupModal={setCreateNewGroupModal}
                              formData={formData}
                            />

                            <InfoItem
                              header="Make"
                              value={vehicleProfileData[0]?.vehicleMakeText}
                            />

                            <InfoItem
                              header="Model"
                              value={vehicleProfileData[0]?.vehicleModelText}
                            />

                            <InfoItem
                              header="Variant"
                              value={vehicleProfileData[0]?.vehicleVariantText}
                            />

                            {rentalPackages.length >= 4 || (String(vehicleProfileData[0]?.vehicleType) === String(vehicleType?.inverted?.bike) && rentalPackages.length === 1) ? (
                              <Field
                                label="status"
                                value={getValue("status")}
                                fieldKey="status"
                                handleChange={handleChange}
                                isEdit={isEdit}
                                type="dropdown"
                                subCategory={subcategoryValues?.vehicleStatus}
                              />
                            ) : (
                              <div>
                                <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
                                  Status
                                </p>
                                <span className="inline-flex px-3 py-1 text-xs font-semibold rounded-full bg-red-50 text-red-700 ring-1 ring-red-200">
                                  {vehicleStatus[vehicleProfileData[0]?.status]}
                                </span>
                              </div>
                            )}

                            {vehicleProfileData &&
                              vehicleProfileData[0]?.vehicleGroupId !== 0 &&
                              vehicleProfileData[0]?.vehicleGroupId !== null &&
                              packageRows?.length > 0 && (
                                <Field
                                  label="Subscription"
                                  value={getValue("isSubscriptionEnabled")}
                                  fieldKey="isSubscriptionEnabled"
                                  handleChange={handleChange}
                                  isEdit={isEdit}
                                  type="dropdown"
                                  subCategory={
                                    subcategoryValues?.isSubscriptionEnabled
                                  }
                                  setCreateNewGroupModal={
                                    setCreateNewGroupModal
                                  }
                                  formData={formData}
                                />
                              )}

                            <InfoItem
                              header="Latest QC Status"
                              value={vehicleProfileData[0]?.latestQcStatus}
                            />

                            <Field
                              label="Engine #"
                              value={getValue("engineNo")}
                              fieldKey="engineNo"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="text"
                            />

                            <Field
                              label="Chassis #"
                              value={getValue("chasisNo")}
                              fieldKey="chasisNo"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="text"
                            />

                            {String(vehicleProfileData[0]?.vehicleType) !==
                              String(vehicleType?.inverted?.bike) ? <Field
                              label="Vehicle Body Type"
                              value={getValue("vehicleBodyType")}
                              fieldKey="vehicleBodyType"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={subcategoryValues?.vehicleBodyType}
                            /> : <></>}

                            <Field
                              label="Fuel Type"
                              value={getValue("fuelType")}
                              fieldKey="fuelType"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={subcategoryValues?.fuelType}
                            />

                            <Field
                              label="Transmission Type"
                              value={getValue("transmissionType")}
                              fieldKey="transmissionType"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={subcategoryValues?.transmissionType}
                            />

                            <Field
                              label="Seater"
                              value={getValue("seater")}
                              fieldKey="seater"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="number"
                            />

                            {String(vehicleProfileData[0]?.vehicleType) ===
                              String(vehicleType?.inverted?.electricCar) ? (
                              <>
                                <Field
                                  label="Driving Range"
                                  value={getValue("drivingRange")}
                                  fieldKey="drivingRange"
                                  handleChange={handleChange}
                                  isEdit={isEdit}
                                  type="text"
                                />

                                <Field
                                  label="Charging Time"
                                  value={getValue("chargingTime")}
                                  fieldKey="chargingTime"
                                  handleChange={handleChange}
                                  isEdit={isEdit}
                                  type="number"
                                />

                                <Field
                                  label="Charging Type"
                                  value={getValue("chargingType")}
                                  fieldKey="chargingType"
                                  handleChange={handleChange}
                                  isEdit={isEdit}
                                  type="text"
                                />

                                {/* <Field
                                  label="Engine Capacity"
                                  value={getValue("engineCapacity")}
                                  fieldKey="engineCapacity"
                                  handleChange={handleChange}
                                  isEdit={isEdit}
                                  type="number"
                                /> */}
                              </>
                            ) : <Field
                              label="Fuel Tank Capacity"
                              value={getValue("fuelTankCapacity")}
                              fieldKey="fuelTankCapacity"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="number"
                            />}

                            <Field
                              label="Registration On"
                              value={getValue("registrationDate")}
                              fieldKey="registrationDate"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="date"
                            />

                            <Field
                              label="Onboarding On"
                              value={getValue("onBoardingDate")}
                              fieldKey="onBoardingDate"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="date"
                            />

                            <Field
                              label="Segment"
                              value={getValue("segment")}
                              fieldKey="segment"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={subcategoryValues?.segmentType}
                            />

                            <Field
                              label="Vehicle Type"
                              value={getValue("vehicleType")}
                              fieldKey="vehicleType"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="dropdown"
                              subCategory={subcategoryValues?.vehicleType}
                            />

                            <Field
                              label="Onboarding Odometer"
                              value={getValue("onBoardingOdometer")}
                              fieldKey="onBoardingOdometer"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="number"
                            />

                            <Field
                              label="Current Odometer"
                              value={getValue("currentOdometer")}
                              fieldKey="currentOdometer"
                              handleChange={handleChange}
                              isEdit={isEdit}
                              type="number"
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <Mygroup
                  getVehicleByLicensePlateAPI={getVehicleByLicensePlateAPI}
                  groupsList={groupsList}
                  setGroupsList={setGroupsList}
                  getGroupsAPI={getGroupsAPI}
                  myGroups={myGroups}
                  selectedRow={selectedRow}
                  vehicleProfileData={vehicleProfileData}
                  getVehicleProfileGroupsAPI={getVehicleProfileGroupsAPI}
                />
                {vehicleProfileData && String(vehicleProfileData[0]?.vehicleType) === String(vehicleType?.inverted?.bike) ? <>
                  <Mybikerentalpackage
                    selectedRow={selectedRow}
                    rentalPackages={rentalPackages}
                    setGroupsList={setGroupsList}
                    groupsList={groupsList}
                    getGroupsAPI={getGroupsAPI}
                    vehicleProfileData={vehicleProfileData}
                    getVehicleProfileRentalPackagesAPI={
                      getVehicleProfileRentalPackagesAPI
                    }
                  />
                </> : <><Mypackages
                  rentalPackages={rentalPackages}
                  groupsList={groupsList}
                  setGroupsList={setGroupsList}
                  getGroupsAPI={getGroupsAPI}
                  selectedRow={selectedRow}
                  vehicleProfileData={vehicleProfileData}
                  getVehicleProfileRentalPackagesAPI={
                    getVehicleProfileRentalPackagesAPI
                  }
                />

                  <Mysubscription
                    loadingGroups={loadingGroups}
                    setLoadingGroups={setLoadingGroups}
                    packageRows={packageRows}
                    setPackageRows={setPackageRows}
                    vehicleProfileData={vehicleProfileData}
                    getSubscriptionPAckageDetails={getSubscriptionPAckageDetails}
                  /></>}
              </>
            ) : activeTab === "documents" ? (
              <>
                <VehicleDocuments
                  vehicleDocuments={vehicleDocuments}
                  getVehicleProfileDocumentsAPI={getVehicleProfileDocumentsAPI}
                  selectedRow={selectedRow}
                  systemUserList={systemUserList}
                  handleImageOpen={handleImageOpen}
                />
              </>
            ) : activeTab === "images" ? (
              <>
                <Vehicleimages
                  vehicleImages={vehicleImages}
                  getVehicleProfileImagesAPI={getVehicleProfileImagesAPI}
                  selectedRow={selectedRow}
                  systemUserList={systemUserList}
                  handleImageOpen={handleImageOpen}
                />
              </>
            ) : activeTab === "financial" ? (
              <>
                {" "}
                <Vehiclefinancialdetails selectedRow={selectedRow} />{" "}
              </>
            ) : activeTab === "mybookings" ? (
              <>
                <Mybookings selectedRow={selectedRow} />
              </>
            ) : activeTab === "myissues" ? (
              <>
                <Myissues selectedRow={selectedRow} />
              </>
            ) : activeTab === "myexpenses" ? (
              <>
                <Myexpenses selectedRow={selectedRow} />
              </>
            ) : activeTab === "batteries" ? (
              <>
                <Batteries selectedRow={selectedRow} />
              </>
            ) : activeTab === "mytyres" ? (
              <>
                <Mytyres selectedRow={selectedRow} />
              </>
            ) : activeTab === "myclutch" ? (
              <>
                <Myclutch
                  handleImageOpen={handleImageOpen}
                  selectedRow={selectedRow}
                />
              </>
            ) : activeTab === "specifications" ? (
              <>
                <Specifications selectedRow={selectedRow} />
              </>
            ) : activeTab === "myworkorders" ? (
              <>
                <Myworkorders selectedRow={selectedRow} />
              </>
            ) : activeTab === "wheelalignmentlogs" ? (
              <>
                <Wheelalignmentlogs
                  handleImageOpen={handleImageOpen}
                  selectedRow={selectedRow}
                />
              </>
            ) : activeTab === "windshield" ? (
              <>
                <Mywindshield
                  handleImageOpen={handleImageOpen}
                  selectedRow={selectedRow}
                />
              </>
            ) : (
              <>
                <Nonrevenuekm selectedRow={selectedRow} />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const Field = ({
  label,
  value,
  fieldKey,
  handleChange,
  isEdit,
  type,
  subCategory,
  setCreateNewGroupModal,
  formData,
}) => (
  <div>
    <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
      {label}
    </p>

    {isEdit ? (
      type === "dropdown" ? (
        <>
          <select
            className="w-full border rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
            value={value || ""}
            onChange={(e) => handleChange(fieldKey, e.target.value)}
          >
            <option value="" disabled>
              Select {label}
            </option>

            {subCategory?.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          {fieldKey === "vehicleGroupText" && (
            <span
              className="text-xs text-gray-400 hover:text-blue-500 cursor-pointer"
              onClick={() => {
                if (formData?.cityId) {
                  setCreateNewGroupModal(true);
                } else {
                  return toast.error("Please Select City and Create new group");
                }
              }}
            >
              Click me to add new group
            </span>
          )}
        </>
      ) : (
        <>
          <input
            type={type}
            className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
            value={value || ""}
            onChange={(e) => handleChange(fieldKey, e.target.value)}
          />
        </>
      )
    ) : (
      /* VIEW MODE */
      <p className="text-sm font-semibold text-gray-900">{value || "-"}</p>
    )}
  </div>
);

function InfoItem({ header, value }) {
  return (
    <div>
      <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
        {header}
      </p>
      <p className="text-sm font-semibold text-gray-900">{value || "N/A"}</p>
    </div>
  );
}
